'use strict'
// Imports
import * as THREE from 'three'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Resources from './Utils/Resources.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import sources from './sources.js'

let instance = null

export default class Experience
{
  constructor(canvas) {
    // Global access
    window.experience = this

    // Options
    this.canvas = canvas

    // Singleton
    if (instance)
    {
      return instance
    }
    instance = this

    // Setup
    this.scene = new THREE.Scene()
    this.resources = new Resources(sources)
    this.sizes = new Sizes()
    this.time = new Time()
    this.camera = new Camera()
    this.renderer = new Renderer()
    this.world = new World()

    // Sizes resize event
    this.sizes.on('resize', () => {
      this.resize()
    })
    // Time tick event
    this.time.on('tick', () => {
      this.update()
    })
  }
  // Resize
  resize()
  {
    this.camera.resize()
    this.renderer.resize()
  }
  // Update
  update()
  {
    this.camera.update()
    this.world.update()
    this.renderer.update()
  }
}